type Params = {
  elementId: string;
  delayInSeconds?: number;
};

export function scrollIntoElementId({ elementId, delayInSeconds = 0 }: Params) {
  setTimeout(() => {
    const firstEl = document.getElementById(elementId);

    firstEl?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  }, delayInSeconds * 1000);
}
